import { AxiosInstance } from "axios";
import { QualificationTierI } from "shared/lib/interfaces/qualification-criteria";

export interface SubmitMeetingQualificationRequestI {
  meeting_result: "show" | "no_show";
  qualification_tier?: QualificationTierI;
}

export interface MeetingQualificationViewI {
  id: string;
  created_at: string;
  meeting_result: string;
  qualification_tier: string | null;
  payout_status: string;
  submitter_name: string;
  submitter_role: string;
  is_disputed: boolean;
}

export interface GetMeetingQualificationResponseI {
  qualification: MeetingQualificationViewI | null;
}

export type MeetingDisputeSourceI = "customer" | "system_duplicate_phone";

export interface MeetingDisputeViewI {
  id: string;
  created_at: string;
  status: string;
  source: MeetingDisputeSourceI;
  is_size_met: boolean;
  reason_size_not_met: string | null;
  is_title_met: boolean;
  reason_title_not_met: string | null;
  is_industry_met: boolean;
  reason_industry_not_met: string | null;
  is_problem_pain_met: boolean;
  reason_problem_pain_not_met: string | null;
  is_timing_budget_met: boolean | null;
  reason_timing_budget_not_met: string | null;
  is_bonus_2_met: boolean | null;
  reason_bonus_2_not_met: string | null;
  evidence_link_url: string | null;
  evidence_notes: string | null;
  resolution_notes: string | null;
}

export interface GetMeetingDisputeResponseI {
  dispute: MeetingDisputeViewI | null;
}

export const MeetingQualificationEndpoints = (API: AxiosInstance) => ({
  submitQualification: (
    campaignId: string,
    accountId: string,
    data: SubmitMeetingQualificationRequestI
  ) =>
    API.post(
      `/v1/campaign/${campaignId}/account/${accountId}/qualification`,
      data
    ),

  getQualification: (campaignId: string, accountId: string) =>
    API.get<GetMeetingQualificationResponseI>(
      `/v1/campaign/${campaignId}/account/${accountId}/qualification`
    ),

  getDispute: (campaignId: string, accountId: string) =>
    API.get<GetMeetingDisputeResponseI>(
      `/v1/campaign/${campaignId}/account/${accountId}/dispute`
    ),
});
